import { UserPermission } from 'modules/Core/types';
import {
  RecordOvenManagementCardFeed,
  recordOvenManagementCardFeed,
} from 'modules/Pilot/BatchRecord/actions';
import { BatchRecord } from 'modules/Pilot/BatchRecord/domain';
import { PartStatus } from 'modules/RecordManagement';
import { SignOffDefinition } from '../SignOffTable/SignOffTable';

export default (
  batchRecord: BatchRecord,
  userId: string,
  userPermissions: UserPermission[]
): SignOffDefinition => {
  const {
    id,
    drying: {
      ovenManagementCardFeed: { status, requiredPermissions, signOffs },
    },
  } = batchRecord;

  const isAllowedToSign = () => {
    if (
      status === PartStatus.Locked ||
      status === PartStatus.ReadOnly ||
      status === PartStatus.Blocked
    )
      return false;
    if (signOffs.find(so => so.user.id === userId)) return false;

    let result = true;
    requiredPermissions?.forEach(req => {
      if (userPermissions.find(perm => perm.name === req) === undefined) result = false;
    });

    return result;
  };

  return {
    signOff: signOffs,
    title: 'Oven Management / Card Feed',
    dialogName: 'pilot/batch-records/OVEN_CARD_FEED',
    reviewText: 'Have you done oven management and/or card feeds?',
    allowsMultiple: true,
    action: recordOvenManagementCardFeed(id),
    api: RecordOvenManagementCardFeed.CALL,
    canSign: isAllowedToSign(),
  };
};
